import type { APIError } from '@utils'

export type CancelFlowStep = 'cancellation-options' | 'churn-reason'

export interface CancelFlowFormValues {
  disableEinvoicing: boolean | undefined
  churnReasons: string[]
  churnReasonOther: string
  keepAddons: boolean | undefined
}

export const cancelFlowDefaultValues: CancelFlowFormValues = {
  disableEinvoicing: undefined,
  churnReasons: [],
  churnReasonOther: '',
  keepAddons: undefined
}

const cancelFlowApiFieldMap: Record<string, keyof CancelFlowFormValues> = {
  churn_reasons: 'churnReasons',
  churn_reason_other: 'churnReasonOther',
  disable_einvoicing: 'disableEinvoicing',
  keep_addons: 'keepAddons'
}

export const mapCancelFlowApiErrors = (errors: APIError): APIError =>
  Object.fromEntries(
    Object.entries(errors).map(([key, value]) => [cancelFlowApiFieldMap[key] ?? key, value])
  )

export const churnReasonSelectionNeedsText = (
  selectedReasons: string[],
  options: { value: string; allows_custom_text: boolean }[] | undefined
): boolean =>
  selectedReasons.some(value => options?.find(option => option.value === value)?.allows_custom_text)
